import React from "react";
import CfcCycleUser from "./CfcCycleUser";
import DateFormatter from "../../../app/formatters/DateFormatter";

export default function CfcCycle({ cfcCycle, cfcWod, cfcCycleRegistrationIds, onClickOnDelete, onClickOnMoveLeft, onClickOnMoveRight, onClickOnAddVirtualCfcCycleUser, onClickOnDeleteVirtualCfcCycleUser }) {
  return (
    <div>
      <h4 className="sections__child__title sections__child__title--flex-space-between">
        Vague n°{cfcCycle.position} - Début le {DateFormatter.formatDate(cfcWod.start_date, false, false, true)} à {cfcCycle.start} - Fin à {cfcCycle.end}
        <div className="flexline flexline--margin">
          <button className="btn btn--only-svg btn--no-label" onClick={() => onClickOnAddVirtualCfcCycleUser(cfcCycle)}>
            <span className="material-icons">group_add</span>
          </button>
          <button className="btn btn--only-svg btn--no-label" onClick={() => onClickOnDeleteVirtualCfcCycleUser(cfcCycle)}>
            <span className="material-icons">delete</span>
          </button>
        </div>
      </h4>
      <div className="space--16"></div>
      <div className="mosaic mosaic--grid-4">
        {cfcCycle.cfc_cycle_users.map((cfcCycleUser, index) => (
          <CfcCycleUser key={cfcCycleUser.custom_id || cfcCycleUser.cfcRegistrationId} cfcCycleUser={cfcCycleUser} cfcWod={cfcWod} cfcCycle={cfcCycle} cfcCycleRegistrationIds={cfcCycleRegistrationIds} onClickOnDelete={() => onClickOnDelete(cfcCycle, cfcCycleUser)} onClickOnMoveLeft={() => onClickOnMoveLeft(cfcCycle, cfcCycleUser)} onClickOnMoveRight={() => onClickOnMoveRight(cfcCycle, cfcCycleUser)}></CfcCycleUser>
        ))}
      </div>
    </div>
  );
}
